import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation } from '../../utils/AppFunctions'
import config from '../../app-config'
import { fetch_config, fetch_config_services } from '../../api/configAPI'
import { fetch_all_special_services_admin, get_service_by_id, create_new_service, update_service, delete_service } from '../../api/servicesAPI'
import { fetch_all_bulletin } from '../../api/bulletinAPI'
import { fetch_sermon_series, create_sermon_series } from '../../api/sermonAPI'
import { fetch_all_users_admin } from '../../api/usersAPI'
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import Switch from 'react-switch'
import Select from 'react-select'
import notify from '../../utils/IANotification';
import JoditEditor from 'jodit-react';
import { MdAdd, MdDelete, MdEdit, MdOpenInBrowser, MdSave, MdArrowBack } from 'react-icons/md';
import ModalLayout from '../../layouts/ModalLayout';
import { captialise_first_letter } from '../../utils/helper';
import FileUploadField from '../../components/FileUploadField';
import SubNavbar from '../../components/ui/SubNavbar';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';

export default function ServicesFormPage() {
  const navigate = useNavigate()
  useFetchAuthorisation("user")
  const [, setLoading] = useState(true)
  let service_id = new URLSearchParams(window.location.search).get("service_id")
  
  // Navigation tabs state
  const [activeTab, setActiveTab] = useState("general")

  const [, setServiceTypeData] = useState([])
  const [sermonSeries, setSermonSeries] = useState([])
  const [usersList, setUsersList] = useState([])
  const [activeRunSheet, setActiveRunSheet] = useState(0)
  const [draggingIndex, setDraggingIndex] = useState(null)
  
  const [serviceFormData, setServiceFormData] = useState({
    service_title: "",
    service_type_id: "",
    service_type_ids: [],
    sermon_series_id: "",
    service_start_datetime: "",
    service_end_datetime: "",
    video_link: "",
    sermon_outline: "",
    sermon_title: "",
    is_special_service: "0",
    special_service_id: "",
    worship_songs: "",
    sermon_link: "",
    worship_link: "",
    bulletin_id: "",
    is_published: "0",
    servers: [
      {
        name: "",
        role: "Worship Leader",
        user_id: ""
      }
    ]
  })

  const [runsheetData, setRunsheetData] = useState([
    {
      runsheet_item: "Welcome & Call to Worship",
      start_time: "08:30",
      duration: "5",
      item_code: "regular",
      personnel_name: "",
      personnel_user_id: "",
      internal_notes: "Lead congregation in opening prayer",
      description: "Welcome to Bedok Methodist Church",
      is_public: "1"
    }
  ])

  const [seriesFormData, setSeriesFormData] = useState({
    title: "",
    description: "",
  })

  const [bulletin, setBulletinData] = useState([])
  const [specialServicesData, setSpecialServicesData] = useState([])
  const [showSeriesModal, setShowSeriesModal] = useState(false)
  const [serviceSettings, setServiceSettings] = useState([])
  const [documents, setDocuments] = useState([])

  const [deleteConfirmation, setDeleteConfirmation] = useState("")
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false)

  const editor = useRef(null)
  const placeholder = "Write sermon outline..."
  const runsheet_items = ["regular", "worship", "announcements", "sermon", "tithe", "prayer"]

  const liveConfig = {
    height: 450,
    placeholder,
    buttons: [
      'bold', 'italic', 'underline', 'strikethrough', 'ul', 'ol',
      'font', 'fontsize', 'brush', 'paragraph', 'table', 'link', 'undo', 'redo', 'eraser'
    ],
    askBeforePasteHTML: false,
  }

  const tabs = [
    { id: 'general', label: 'General Settings' },
    { id: 'runsheet', label: 'Runsheet' },
    { id: 'sermon', label: 'Sermon & Media' },
    { id: 'servers', label: 'Servers Roster' },
  ]

  const handleSubmit = () => {
    if (service_id === "new") {
      createService()
    } else {
      updateService()
    }
  }

  const fetchConfigSettings = async () => {
    const { data, error, status } = await fetch_config()
    if (!error && status === 200) {
      setServiceSettings(data.services || [])
    }
  }

  const fetchSpecialServices = async () => {
    const { data, error, status } = await fetch_all_special_services_admin()
    if (!error && status === 200) {
      let service_data = data || []
      service_data.sort((a, b) => new Date(b.service_start_datetime) - new Date(a.service_start_datetime))
      setSpecialServicesData(service_data)
    }
  }

  const fetchBulletIn = async () => {
    const { data, error, status } = await fetch_all_bulletin()
    if (!error && status === 200) setBulletinData(data || [])
  }

  const fetchServiceTypes = async () => {
    const { data, error, status } = await fetch_config_services()
    if (!error && status === 200) setServiceTypeData(data || [])
  }

  const fetchUsers = async () => {
    const { data, error } = await fetch_all_users_admin()
    if (!error && Array.isArray(data)) {
      setUsersList(data.map(u => ({
        value: u.id,
        label: `${u.first_name || ''} ${u.last_name || ''} (${u.email || u.mobile_phone || u.id})`.trim()
      })))
    }
  }

  const fetchServiceById = useCallback(async () => {
    if (service_id !== "new") {
      setLoading(true)
      const { data, error, status } = await get_service_by_id(service_id)
      if (!error && status === 200) {
        setServiceFormData({
          ...data.service,
          servers: data.service?.servers || [{ name: "", role: "Worship Leader", user_id: "" }]
        })
        setRunsheetData(data.runsheet || [])
        setDocuments(data.documents || [])
      }
    }
    setLoading(false)
  }, [service_id])

  const fetchSermonSeries = async () => {
    const { data, error, status } = await fetch_sermon_series()
    if (!error && status === 200) setSermonSeries(data || [])
  }

  useEffect(() => {
    fetchServiceTypes()
    fetchServiceById()
    fetchSermonSeries()
    fetchBulletIn()
    fetchSpecialServices()
    fetchConfigSettings()
    fetchUsers()
  }, [service_id, fetchServiceById])

  const createService = async () => {
    const { data, error, status } = await create_new_service({ ...serviceFormData, runsheet: runsheetData })
    if (!error && status === 200) {
      navigate('/admin/services/details?service_id=' + data.id)
      notify({ type: 'success', message: 'Successfully created service' })
    } else {
      notify({ type: 'error', message: 'Unable to create service' })
    }
  }

  const updateService = async () => {
    if (!service_id || service_id === "new") return notify({ type: "error", message: "Unable to update service" })
    const { error, status } = await update_service(service_id, { ...serviceFormData, runsheet: runsheetData, documents })
    if (!error && status === 200) {
      fetchServiceById()
      notify({ type: 'success', message: 'Successfully updated service' })
    } else {
      notify({ type: 'error', message: 'Unable to update service' })
    }
  }

  const deleteService = async () => {
    if (!service_id || service_id === 'new') return
    const { error, status } = await delete_service(service_id)
    if (!error && status === 200) {
      navigate('/admin/services')
    } else {
      notify({ type: 'error', message: 'Unable to delete service' })
    }
  }

  const createSeries = async () => {
    const { error, status } = await create_sermon_series({ title: seriesFormData.title, description: seriesFormData.description })
    if (!error && status === 200) {
      fetchSermonSeries()
      setShowSeriesModal(false)
      notify({ type: 'success', message: 'Successfully created new series' })
    } else {
      notify({ type: 'error', message: 'Unable to create new series' })
    }
  }

  return (
    <AdminLayout
      navSelected={"Services"}
      headerText={service_id === "new" ? "New Service" : "Edit Service"}
      toolbar={
        <>
          <div className="flex items-center gap-3">
            <Button variant="outline" icon={MdArrowBack} onClick={() => navigate('/admin/services')}>
              Back
            </Button>
            <h1 className="text-xl font-bold text-gray-900">
              {service_id === "new" ? "Create Service" : serviceFormData.service_title || "Edit Service"}
            </h1>
          </div>

          <div className="flex gap-2">
            {service_id !== "new" && (
              <Button variant="danger" icon={MdDelete} onClick={() => setShowDeleteConfirmationModal(true)}>
                Delete
              </Button>
            )}
            <Button variant="primary" icon={MdSave} onClick={handleSubmit}>
              {service_id === "new" ? "Create Service" : "Save Changes"}
            </Button>
          </div>
        </>
      }
    >
      {/* SubNavbar */}
      <SubNavbar
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />

      {/* Series Modal */}
      <ModalLayout modalTitle="Create Sermon Series" isVisible={showSeriesModal} setIsVisible={setShowSeriesModal}>
        <div className="space-y-4">
          <div className="input-container">
            <label className="input-label font-semibold">Series Title</label>
            <input type="text" className="text-input" value={seriesFormData.title} onChange={(e) => setSeriesFormData({ ...seriesFormData, title: e.target.value })} placeholder="e.g. Gospel of Mark" />
          </div>
          <div className="input-container">
            <label className="input-label font-semibold">Description</label>
            <textarea className="textarea-input" value={seriesFormData.description} onChange={(e) => setSeriesFormData({ ...seriesFormData, description: e.target.value })} placeholder="Series description..." />
          </div>
          <div className="flex justify-end pt-2">
            <Button variant="primary" onClick={createSeries}>Create Series</Button>
          </div>
        </div>
      </ModalLayout>

      {/* Delete Confirmation Modal */}
      <ModalLayout modalTitle={`Delete Service: ${serviceFormData?.service_title}`} isVisible={showDeleteConfirmationModal} setIsVisible={setShowDeleteConfirmationModal}>
        <div className="space-y-4">
          <p className="text-sm text-gray-600">To confirm deletion, please type <strong className="text-red-600">delete</strong> below.</p>
          <input type="text" className="text-input" value={deleteConfirmation} onChange={(e) => setDeleteConfirmation(e.target.value)} placeholder="Type 'delete'" />
          <div className="flex justify-end pt-2">
            <Button variant="danger" onClick={() => {
              if (deleteConfirmation === "delete") deleteService()
              else notify({ type: "error", message: "Please type 'delete' to confirm deletion" })
            }}>
              Confirm Delete
            </Button>
          </div>
        </div>
      </ModalLayout>

      {/* TAB 1: GENERAL SETTINGS */}
      {activeTab === "general" && (
        <div className="space-y-6">
          <Card title="General Service Information" subtitle="Configure core service details, profile associations, and publication status.">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="input-container md:col-span-2">
                <label className="input-label font-semibold">Service Title</label>
                <input
                  type="text"
                  className="text-input"
                  value={serviceFormData.service_title || ""}
                  onChange={(e) => setServiceFormData({ ...serviceFormData, service_title: e.target.value })}
                  placeholder="e.g. Sunday Morning Contemporary Worship"
                />
              </div>

              <div className="input-container">
                <label className="input-label font-semibold">Start Date &amp; Time</label>
                <input
                  type="datetime-local"
                  className="text-input"
                  value={serviceFormData.service_start_datetime || ""}
                  onChange={(e) => setServiceFormData({ ...serviceFormData, service_start_datetime: e.target.value })}
                />
              </div>

              <div className="input-container">
                <label className="input-label font-semibold">End Date &amp; Time</label>
                <input
                  type="datetime-local"
                  className="text-input"
                  value={serviceFormData.service_end_datetime || ""}
                  onChange={(e) => setServiceFormData({ ...serviceFormData, service_end_datetime: e.target.value })}
                />
              </div>

              <div className="flex items-center gap-4 bg-gray-50 p-4 rounded-xl border border-gray-200">
                <Switch
                  onChange={(checked) => setServiceFormData({ ...serviceFormData, is_published: checked ? "1" : "0" })}
                  checked={serviceFormData.is_published === "1"}
                />
                <div>
                  <p className="text-sm font-semibold text-gray-900">Publish Service</p>
                  <p className="text-xs text-gray-500">Make this service visible on the church website &amp; app.</p>
                </div>
              </div>

              <div className="flex items-center gap-4 bg-gray-50 p-4 rounded-xl border border-gray-200">
                <Switch
                  onChange={(checked) => setServiceFormData({ ...serviceFormData, is_special_service: checked ? "1" : "0" })}
                  checked={serviceFormData.is_special_service === "1"}
                />
                <div>
                  <p className="text-sm font-semibold text-gray-900">Special Service</p>
                  <p className="text-xs text-gray-500">Mark as special event or holiday service.</p>
                </div>
              </div>
            </div>

            {serviceFormData?.is_special_service === "1" && (
              <div className="mt-6 pt-6 border-t border-gray-200">
                <label className="input-label font-semibold">Select Special Service Category</label>
                <Select
                  options={specialServicesData.map(s => ({ value: s.id, label: s.name }))}
                  value={specialServicesData.map(s => ({ value: s.id, label: s.name })).find(s => s.value === serviceFormData?.special_service_id)}
                  onChange={(e) => setServiceFormData({ ...serviceFormData, special_service_id: e.value })}
                />
              </div>
            )}
          </Card>

          <Card title="Associated Service Profiles" subtitle="Select which Service Profiles this service belongs to.">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {serviceSettings?.map((service) => {
                const isSelected = serviceFormData?.service_type_ids?.includes(service.id)
                return (
                  <div key={service.id} className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl border border-gray-200">
                    <Switch
                      checked={!!isSelected}
                      onChange={(checked) => {
                        let newTypes = [...(serviceFormData.service_type_ids || [])]
                        if (checked) {
                          if (!newTypes.includes(service.id)) newTypes.push(service.id)
                        } else {
                          newTypes = newTypes.filter(id => id !== service.id)
                        }
                        setServiceFormData({ ...serviceFormData, service_type_ids: newTypes })
                      }}
                    />
                    <span className="text-sm font-medium text-gray-800">{service.name}</span>
                  </div>
                )
              })}
            </div>
          </Card>

          {service_id !== "new" && service_id && (
            <Card title="Service Header Image">
              <FileUploadField
                text="Upload Service Header"
                upload_url={config.endpoint + "/file/services/id/" + service_id}
                onChange={() => {}}
                subtext="Upload header graphic for service display"
                item_index={0}
              />
            </Card>
          )}
        </div>
      )}

      {/* TAB 2: RUNSHEET */}
      {activeTab === "runsheet" && (
        <Card
          title="Service Runsheet Order"
          subtitle="Define items, timing, and assign registered users or type manual personnel names."
          headerRight={
            <Button
              variant="primary"
              icon={MdAdd}
              onClick={() => {
                let newRunsheet = [...runsheetData]
                let previousTime = newRunsheet.length > 0 ? newRunsheet[newRunsheet.length - 1].start_time : "08:30"
                let previousDuration = newRunsheet.length > 0 ? newRunsheet[newRunsheet.length - 1].duration || "5" : "5"
                let nextStartTime = new Date("1970-01-01T" + (previousTime || "08:30"))
                nextStartTime.setMinutes(nextStartTime.getMinutes() + parseInt(previousDuration || 5))
                nextStartTime = nextStartTime.toTimeString().slice(0, 5)

                newRunsheet.push({
                  runsheet_item: "",
                  start_time: nextStartTime,
                  duration: "5",
                  internal_notes: "",
                  description: "",
                  personnel_name: "",
                  personnel_user_id: "",
                  item_code: "regular",
                  is_public: "1"
                })
                setActiveRunSheet(newRunsheet.length - 1)
                setRunsheetData(newRunsheet)
              }}
            >
              Add Item
            </Button>
          }
        >
          <div className="space-y-4">
            {runsheetData.map((item, index) => {
              const isEditing = activeRunSheet === index
              return (
                <div
                  key={index}
                  draggable={true}
                  onDragStart={(e) => {
                    e.dataTransfer.effectAllowed = 'move'
                    try { e.dataTransfer.setData('text/plain', String(index)) } catch (err) {}
                    setDraggingIndex(index)
                  }}
                  onDragOver={(e) => { e.preventDefault(); e.dataTransfer.dropEffect = 'move' }}
                  onDrop={(e) => {
                    e.preventDefault()
                    const fromIndexRaw = e.dataTransfer.getData('text/plain')
                    const fromIndex = fromIndexRaw !== '' ? parseInt(fromIndexRaw, 10) : draggingIndex
                    if (fromIndex === undefined || fromIndex === null || isNaN(fromIndex) || fromIndex === index) {
                      setDraggingIndex(null)
                      return
                    }
                    const newRunsheet = [...runsheetData]
                    const [moved] = newRunsheet.splice(fromIndex, 1)
                    newRunsheet.splice(index, 0, moved)
                    setRunsheetData(newRunsheet)
                    setDraggingIndex(null)
                  }}
                  onDragEnd={() => setDraggingIndex(null)}
                  className={`p-5 rounded-2xl border transition-all ${
                    isEditing
                      ? "bg-blue-50/50 border-blue-300 shadow-sm"
                      : "bg-gray-50 border-gray-200"
                  }`}
                >
                  <div className="flex items-center justify-between gap-4 cursor-pointer" onClick={() => setActiveRunSheet(index)}>
                    <div className="flex items-center gap-3">
                      <span className="w-7 h-7 flex items-center justify-center bg-gray-200 text-gray-700 rounded-full font-bold text-xs">
                        {index + 1}
                      </span>
                      <div>
                        <h4 className="font-bold text-sm text-gray-900">
                          {item.runsheet_item || "Untitled Runsheet Item"}
                        </h4>
                        <p className="text-xs text-gray-500">
                          {item.personnel_name ? `Personnel: ${item.personnel_name}` : "No personnel assigned"}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <Button variant="outline" size="sm" icon={MdEdit} onClick={(e) => { e.stopPropagation(); setActiveRunSheet(index) }}>
                        {isEditing ? "Editing" : "Edit"}
                      </Button>
                      <Button variant="danger" size="sm" icon={MdDelete} onClick={(e) => {
                        e.stopPropagation()
                        let newRunsheet = [...runsheetData]
                        newRunsheet.splice(index, 1)
                        setRunsheetData(newRunsheet)
                      }}>
                        Delete
                      </Button>
                    </div>
                  </div>

                  {isEditing && (
                    <div className="mt-6 pt-6 border-t border-gray-200 space-y-4">
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div className="input-container md:col-span-2">
                          <label className="input-label font-semibold">Item Title</label>
                          <input
                            type="text"
                            className="text-input"
                            value={item.runsheet_item || ""}
                            onChange={(e) => {
                              let temp = [...runsheetData]
                              temp[index].runsheet_item = e.target.value
                              setRunsheetData(temp)
                            }}
                            placeholder="e.g. Opening Hymn / Prayer"
                          />
                        </div>

                        <div className="input-container">
                          <label className="input-label font-semibold">Category Code</label>
                          <Select
                            options={runsheet_items.map(r => ({ value: r, label: captialise_first_letter(r) }))}
                            value={runsheet_items.map(r => ({ value: r, label: captialise_first_letter(r) })).find(r => r.value === item.item_code)}
                            onChange={(e) => {
                              let temp = [...runsheetData]
                              temp[index].item_code = e.value
                              setRunsheetData(temp)
                            }}
                          />
                        </div>
                      </div>

                      {/* Dual Personnel Assignment: Registered User OR Manual Name Entry */}
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-white p-4 rounded-xl border border-gray-200">
                        <div className="input-container">
                          <label className="input-label font-semibold">Assign Registered User</label>
                          <Select
                            isClearable
                            placeholder="Select registered user..."
                            options={usersList}
                            value={usersList.find(u => String(u.value) === String(item.personnel_user_id))}
                            onChange={(selected) => {
                              let temp = [...runsheetData]
                              temp[index].personnel_user_id = selected ? selected.value : ""
                              if (selected && !temp[index].personnel_name) {
                                temp[index].personnel_name = selected.label.split('(')[0].trim()
                              }
                              setRunsheetData(temp)
                            }}
                          />
                        </div>

                        <div className="input-container">
                          <label className="input-label font-semibold">Or Enter Manual Personnel Name</label>
                          <input
                            type="text"
                            className="text-input"
                            value={item.personnel_name || ""}
                            onChange={(e) => {
                              let temp = [...runsheetData]
                              temp[index].personnel_name = e.target.value
                              setRunsheetData(temp)
                            }}
                            placeholder="e.g. Guest Speaker Rev John Doe"
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="input-container">
                          <label className="input-label font-semibold">Internal Notes (Staff Only)</label>
                          <textarea
                            className="textarea-input"
                            value={item.internal_notes || ""}
                            onChange={(e) => {
                              let temp = [...runsheetData]
                              temp[index].internal_notes = e.target.value
                              setRunsheetData(temp)
                            }}
                            placeholder="Notes for AV / Tech team..."
                          />
                        </div>

                        <div className="input-container">
                          <label className="input-label font-semibold">Public Description</label>
                          <textarea
                            className="textarea-input"
                            value={item.description || ""}
                            onChange={(e) => {
                              let temp = [...runsheetData]
                              temp[index].description = e.target.value
                              setRunsheetData(temp)
                            }}
                            placeholder="Public outline description..."
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </Card>
      )}

      {/* TAB 3: SERMON & MEDIA */}
      {activeTab === "sermon" && (
        <div className="space-y-6">
          <Card title="Sermon &amp; Message Details">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div className="input-container">
                <label className="input-label font-semibold">Sermon Title</label>
                <input
                  type="text"
                  className="text-input"
                  value={serviceFormData.sermon_title || ""}
                  onChange={(e) => setServiceFormData({ ...serviceFormData, sermon_title: e.target.value })}
                  placeholder="e.g. Walking by Faith"
                />
              </div>

              <div className="input-container">
                <div className="flex justify-between items-center mb-1">
                  <label className="input-label font-semibold">Sermon Series</label>
                  <button type="button" className="text-xs text-blue-600 hover:underline font-semibold" onClick={() => setShowSeriesModal(true)}>
                    + Create Series
                  </button>
                </div>
                <Select
                  options={sermonSeries.map(s => ({ value: s.id, label: s.title }))}
                  value={sermonSeries.map(s => ({ value: s.id, label: s.title })).find(s => s.value === serviceFormData.sermon_series_id)}
                  onChange={(e) => setServiceFormData({ ...serviceFormData, sermon_series_id: e.value })}
                />
              </div>
            </div>

            <div className="input-container">
              <label className="input-label font-semibold mb-2 block">Sermon Outline (Rich Text)</label>
              <JoditEditor
                ref={editor}
                disableAutoFocus={true}
                value={serviceFormData.sermon_outline || ""}
                config={liveConfig}
                onBlur={(newContent) => setServiceFormData({ ...serviceFormData, sermon_outline: newContent })}
              />
            </div>
          </Card>

          <Card title="Media Embed Links &amp; Bulletins">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
              <div className="input-container">
                <label className="input-label font-semibold">Video Stream Link</label>
                <input
                  type="text"
                  className="text-input"
                  placeholder="https://www.youtube.com/embed/..."
                  value={serviceFormData.video_link || ""}
                  onChange={(e) => setServiceFormData({ ...serviceFormData, video_link: e.target.value })}
                />
              </div>

              <div className="input-container">
                <label className="input-label font-semibold">Worship Video Link</label>
                <input
                  type="text"
                  className="text-input"
                  placeholder="https://www.youtube.com/embed/..."
                  value={serviceFormData.worship_link || ""}
                  onChange={(e) => setServiceFormData({ ...serviceFormData, worship_link: e.target.value })}
                />
              </div>

              <div className="input-container">
                <label className="input-label font-semibold">Sermon Video Link</label>
                <input
                  type="text"
                  className="text-input"
                  placeholder="https://www.youtube.com/embed/..."
                  value={serviceFormData.sermon_link || ""}
                  onChange={(e) => setServiceFormData({ ...serviceFormData, sermon_link: e.target.value })}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="input-container">
                <label className="input-label font-semibold">Attach Church Bulletin</label>
                <Select
                  options={bulletin.map(b => ({ value: b.id, label: b.title }))}
                  value={bulletin.map(b => ({ value: b.id, label: b.title })).find(b => b.value === serviceFormData.bulletin_id)}
                  onChange={(e) => setServiceFormData({ ...serviceFormData, bulletin_id: e.value })}
                />
              </div>

              <div className="input-container">
                <label className="input-label font-semibold">Worship Set List</label>
                <textarea
                  className="textarea-input h-24"
                  placeholder="1. Here I Bow&#10;2. What A Beautiful Name"
                  value={serviceFormData.worship_songs || ""}
                  onChange={(e) => setServiceFormData({ ...serviceFormData, worship_songs: e.target.value })}
                />
              </div>
            </div>
          </Card>
        </div>
      )}

      {/* TAB 4: SERVERS ROSTER */}
      {activeTab === "servers" && (
        <Card
          title="Duty Roster &amp; Server Assignments"
          subtitle="Assign registered church members/staff or type server roles &amp; names manually."
          headerRight={
            <Button
              variant="primary"
              icon={MdAdd}
              onClick={() => {
                let newServers = [...(serviceFormData.servers || [])]
                newServers.push({ name: "", role: "Usher", user_id: "" })
                setServiceFormData({ ...serviceFormData, servers: newServers })
              }}
            >
              Add Server Role
            </Button>
          }
        >
          <div className="space-y-4">
            {serviceFormData.servers?.map((server, index) => {
              return (
                <div key={index} className="p-4 bg-gray-50 rounded-2xl border border-gray-200 grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
                  <div className="input-container">
                    <label className="input-label font-semibold">Server Duty Role</label>
                    <input
                      type="text"
                      className="text-input"
                      value={server.role || ""}
                      onChange={(e) => {
                        let newServers = [...serviceFormData.servers]
                        newServers[index].role = e.target.value
                        setServiceFormData({ ...serviceFormData, servers: newServers })
                      }}
                      placeholder="e.g. Worship Leader, Usher, AV Tech"
                    />
                  </div>

                  {/* Registered User Dropdown */}
                  <div className="input-container">
                    <label className="input-label font-semibold">Assign Registered User</label>
                    <Select
                      isClearable
                      placeholder="Select user..."
                      options={usersList}
                      value={usersList.find(u => String(u.value) === String(server.user_id))}
                      onChange={(selected) => {
                        let newServers = [...serviceFormData.servers]
                        newServers[index].user_id = selected ? selected.value : ""
                        if (selected && !newServers[index].name) {
                          newServers[index].name = selected.label.split('(')[0].trim()
                        }
                        setServiceFormData({ ...serviceFormData, servers: newServers })
                      }}
                    />
                  </div>

                  {/* Manual Name Entry & Delete Action */}
                  <div className="flex items-center gap-3">
                    <div className="input-container flex-1">
                      <label className="input-label font-semibold">Or Enter Name Manually</label>
                      <input
                        type="text"
                        className="text-input"
                        value={server.name || ""}
                        onChange={(e) => {
                          let newServers = [...serviceFormData.servers]
                          newServers[index].name = e.target.value
                          setServiceFormData({ ...serviceFormData, servers: newServers })
                        }}
                        placeholder="e.g. Mary Tan"
                      />
                    </div>

                    <Button
                      variant="danger"
                      icon={MdDelete}
                      onClick={() => {
                        let newServers = [...serviceFormData.servers]
                        newServers.splice(index, 1)
                        setServiceFormData({ ...serviceFormData, servers: newServers })
                      }}
                    >
                      Remove
                    </Button>
                  </div>
                </div>
              )
            })}
          </div>
        </Card>
      )}
    </AdminLayout>
  )
}
